import { $ReadOnly } from 'utility-types';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { OrgType } from 'api/orgs';

export const ORG_TYPES: ReadonlyArray<
  $ReadOnly<{
    id: OrgType;
    name: string;
  }>
> = [
  {
    id: 'NONPROFIT',
    name:
      /* TRANSLATORS: org type */
      getText('Nonprofit'),
  },
  {
    id: 'GOVERNMENT',
    name:
      /* TRANSLATORS: org type */
      getText('Government'),
  },
  {
    id: 'RECRUITER',
    name:
      /* TRANSLATORS: org type */
      getText('Recruiter'),
  },
  {
    id: 'CONSULTANT',
    name:
      /* TRANSLATORS: org type */
      getText('Consultant'),
  },
  {
    id: 'CORPORATION',
    name:
      /* TRANSLATORS: org type */
      getText('Business'),
  },
];
